import { render, staticRenderFns } from "./SubmitReturns.vue?vue&type=template&id=7aa321da&scoped=true"
import script from "./SubmitReturns.vue?vue&type=script&lang=js"
export * from "./SubmitReturns.vue?vue&type=script&lang=js"
import style0 from "./SubmitReturns.vue?vue&type=style&index=0&id=7aa321da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa321da",
  null
  
)

export default component.exports